import dayjs, { Dayjs } from 'dayjs'

export const isNonBusinessDay = (
  date: Dayjs,
  isSaturdayABusinessDay: boolean | undefined,
  publicHolidays: Set<string>,
  /** When set from Prismic `disable_sunday_on_date_picker`, Sundays are non-business. */
  disableSundayFromCms?: boolean
): boolean => {
  const day = date.day()
  const isSunday = day === 0
  const isSaturday = day === 6
  const isHoliday = publicHolidays.has(date.format('YYYY-MM-DD'))
  return (
    (!!disableSundayFromCms && isSunday) ||
    (!isSaturdayABusinessDay && isSaturday) ||
    isHoliday
  )
}

export const getMinimumStartDate = (
  minimumStartingDays: number,
  isSaturdayABusinessDay: boolean | undefined,
  publicHolidays: Set<string>,
  disableSundayFromCms?: boolean
): Dayjs => {
  let startDate = dayjs()
  let businessDaysCount = 0

  while (businessDaysCount < minimumStartingDays) {
    startDate = startDate.add(1, 'day')
    if (
      !isNonBusinessDay(
        startDate,
        isSaturdayABusinessDay,
        publicHolidays,
        disableSundayFromCms
      )
    ) {
      businessDaysCount += 1
    }
  }

  return startDate
}
